// actually taken from tribute internals,
// not part of the offical api so have duplicated
// https://github.com/zurb/tribute/blob/470a3139fa2f76de4597b10322d768a3f3cb813c/src/Tribute.js#L322
export const placeCaretAtEnd = (el: HTMLDivElement) => {
  el.focus()
  if (
    typeof window.getSelection !== 'undefined' &&
    typeof document.createRange !== 'undefined'
  ) {
    const range = document.createRange()
    range.selectNodeContents(el)
    range.collapse(false)
    const sel = window.getSelection()
    if (sel) {
      sel.removeAllRanges()
      sel.addRange(range)
    }
  }
}

// Get a Range object for the current selection/caret position
export const getCurrentRange = () => {
  if (window.getSelection) {
    const sel = window.getSelection()
    if (sel?.getRangeAt && sel?.rangeCount) {
      return sel.getRangeAt(0)
    }
  }
  return undefined
}

// Restore a saved Selection/caret position
export const restoreRange = (range: Range) => {
  if (range) {
    if (window.getSelection) {
      const sel = window.getSelection()
      sel?.removeAllRanges()
      sel?.addRange(range)
    }
  }
}

// check if a DOM node is contained within a given container element
export const isOrContains = (child: Node, container: Element) => {
  let node: Node | null = child

  while (node) {
    if (node === container) {
      return true
    }
    node = node.parentNode
  }
  return false
}

// check if a given element contains the current selection
export const elementContainsSelection = (el: Element) => {
  let sel: Selection | null
  if (window.getSelection) {
    sel = window.getSelection()
    if (sel?.rangeCount && sel?.rangeCount > 0) {
      for (let i = 0; i < sel.rangeCount; ++i) {
        if (!isOrContains(sel.getRangeAt(i).commonAncestorContainer, el)) {
          return false
        }
      }
      return true
    }
  }
  return false
}
